'use strict';
function shouldProcessEveryNode(node) {
  return true;
}

module.exports = {
  shouldProcessEveryNode: shouldProcessEveryNode,
};



//////////////////
// WEBPACK FOOTER
// ./~/html-to-react/lib/should-process-node-definitions.js
// module id = 641
// module chunks = 0